import { atomEffect } from "jotai-effect";

import { formAtom } from "@frontend/lib/form";

import {
  contactAddressSchema,
  defaultContactAddressFormData,
} from "../schemas/contactAddress";
import {
  contactAddressContactIdAtom,
  contactAddressDefaultPlaceAtom,
  isContactAddressVisibleAtom,
} from "./contactAddressVisibility";

export const contactAddressForm = formAtom(
  contactAddressSchema,
  defaultContactAddressFormData,
);

// Reset the form and pre-fill the contact/place every time the modal opens.
// Depends on the narrow visibility/contactId/place reads, not the raw
// `contactAddressModalAtom`, so it doesn't re-fire on unrelated changes.
export const contactAddressFormSyncEffect = atomEffect((get, set) => {
  const isVisible = get(isContactAddressVisibleAtom);
  const contactId = get(contactAddressContactIdAtom);
  const defaultPlace = get(contactAddressDefaultPlaceAtom);

  if (isVisible) {
    set(contactAddressForm.actions.setInitial, {
      ...defaultContactAddressFormData,
      contactId,
      place: defaultPlace,
    });
  }
});
